export default "__VITE_ASSET__0951d7e4__"